import React, { useState, useEffect, useCallback } from 'react';
import { Button } from '@/components/ui/button';
import { zohoAPI } from '@/lib/api';
import { toast } from 'sonner';
import { Loader2, ArrowLeft } from 'lucide-react';
import ZohoEntityList from '@/components/zoho/ZohoEntityList';
import EntityDetailView from '@/components/zoho/EntityDetailView';

export default function ZohoSmartDashboard({ form }) {
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPk, setSelectedPk] = useState(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [search, setSearch] = useState('');
  const [excludeTest, setExcludeTest] = useState(true);

  const fetchEntities = useCallback(async () => {
    setLoading(true);
    try {
      const params = { exclude_test: excludeTest };
      if (dateFrom) params.date_from = dateFrom;
      if (dateTo) params.date_to = dateTo;
      if (search) params.search = search;
      const res = await zohoAPI.getFormEntities(form.id, params);
      setEntities(res.data.entities || []);
    } catch (e) {
      toast.error('Failed to load entities');
      setEntities([]);
    }
    setLoading(false);
  }, [form.id, excludeTest, dateFrom, dateTo, search]);

  useEffect(() => { fetchEntities(); }, [fetchEntities]);

  const selectedEntity = entities.find(e => e.primary_key === selectedPk) || null;

  if (loading) {
    return <div className="flex justify-center py-12"><Loader2 className="h-8 w-8 animate-spin text-muted-foreground" /></div>;
  }

  if (selectedEntity) {
    return (
      <div className="space-y-4" data-testid="smart-dashboard-detail">
        <Button variant="ghost" size="sm" onClick={() => setSelectedPk(null)} className="gap-1" data-testid="entity-back-btn">
          <ArrowLeft className="h-4 w-4" />Back to list
        </Button>
        <EntityDetailView entity={selectedEntity} form={form} />
      </div>
    );
  }

  return (
    <ZohoEntityList
      entities={entities}
      form={form}
      onSelect={setSelectedPk}
      dateFrom={dateFrom}
      dateTo={dateTo}
      search={search}
      excludeTest={excludeTest}
      onDateFromChange={setDateFrom}
      onDateToChange={setDateTo}
      onSearchChange={setSearch}
      onExcludeTestChange={setExcludeTest}
      onRefresh={fetchEntities}
    />
  );
}
